import React, {useEffect, useContext} from 'react';
import {Switch, Route, Redirect} from 'react-router';
import {connect} from 'react-redux';
import SignInPage from './pages/Authentication/SignInPage';
import SignUpPage from './pages/Authentication/SignUpPage';
import ResetPasswordPage from './pages/Authentication/ResetPasswordPage';
import FinishRegistrationPage from './pages/Authentication/FinishRegistrationPage';
import InviteUserPage from './pages/Authentication/InviteUserPage';
import FeedsPage from './pages/Feeds';
import PrivacyPolicyPage from './pages/PrivacyPolicy/PrivacyPolicyPage';
import TermsOfService from './pages/PrivacyPolicy/TermsOfService';
import MyAccount from './pages/Account';
import NotFound from './pages/Page404';
import CreateFeed from './pages/CreateFeed/index';
import FeedReader from './pages/FeedReader/index';
import EntityHomePage from './pages/HomeEntitiesPage';
import EditEntityScreen from './pages/AddEntity/indexNew';
import SearchPage from './pages/SearchPage';
import ExpiredToken from './pages/ExpiredToken';
import UsersList from './pages/Users/index';
import {EntityContext} from 'contexts/EntityContext';
import {SavedSearchContext} from 'contexts/SavedSearchContext';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import NewPasswordPage from './pages/Authentication/newPasswordPage';


const Routes = ({auth}) => {

    const {setActiveEntity} = useContext(EntityContext);
    const {setActiveSavedSearch} = useContext(SavedSearchContext);

    useEffect(() => {
        setActiveEntity(null);
        setActiveSavedSearch(null);
    }, [auth.isAuthenticated]);

    return (
        <Switch>
            <Route
                exact
                path="/"
                render={() => {
                    return auth.permissions ?
                        (
                            auth.permissions.includes('entity') ?
                                <Redirect to="/home"/>
                                :
                                <Redirect to="/feeds/fetches"/>
                        )
                        :
                        <Redirect to="/signin"/>;
                }}
            />

            <Route path="/signin">
                <SignInPage/>
            </Route>
            <Route path="/signup">
                <SignUpPage/>
            </Route>
            <PublicRoute path="/reset">
                <ResetPasswordPage/>
            </PublicRoute>
            <PublicRoute path="/link-expired">
                <ExpiredToken/>
            </PublicRoute>
            <PublicRoute path="/link-expired">
                <ExpiredToken/>
            </PublicRoute>
            <PublicRoute path="/new_password">
                <NewPasswordPage/>
            </PublicRoute>
            <PublicRoute path="/finish">
                <FinishRegistrationPage/>
            </PublicRoute>
            <PublicRoute path="/invite">
                <InviteUserPage/>
            </PublicRoute>

            <Route path="/404" component={NotFound}/>

            <PrivateRoute path="/feeds">
                <FeedsPage/>
            </PrivateRoute>
            <PrivateRoute path="/ticker">
                <FeedReader/>
            </PrivateRoute>
            <PrivateRoute path="/settings">
                <MyAccount/>
            </PrivateRoute>
            <PrivateRoute path="/settings">
                <MyAccount/>
            </PrivateRoute>
            <PrivateRoute requiredPermission="search" path="/saved-searches">
                <SearchPage/>
            </PrivateRoute>
            <PrivateRoute requiredPermission="entity" path="/home/:activeIdFromUrl?">
                <EntityHomePage/>
            </PrivateRoute>
            <PrivateRoute path="/main">
                <CreateFeed/>
            </PrivateRoute>

            <PrivateRoute requiredPermission="entity" path="/edit-entity/:idForEditMode?/:activeSourceTypeFromUrl?">
                <EditEntityScreen key={'edit'}/>
            </PrivateRoute>

            <PrivateRoute requiredPermission="entity" path="/add-entity">
                <EditEntityScreen key={'add'}/>
            </PrivateRoute>
            <PrivateRoute path="/users">
                <UsersList/>
            </PrivateRoute>
            <PrivateRoute path="/privacy-policy">
                <PrivacyPolicyPage/>
            </PrivateRoute>
            <PrivateRoute path="/terms-of-service">
                <TermsOfService/>
            </PrivateRoute>

            <Route exact path="/404" component={NotFound}/>

            <Route path="*">
                <Redirect to="/404"/>
            </Route>
        </Switch>
    );
};

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(Routes);

